import { Users, ShieldCheck, KeyRound } from "lucide-react";
import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";

const FEATURES = [
  { icon: Users, title: "Shared workspaces", body: "Flows and notebooks live in projects inside workspaces, so your team works from the same analyses." },
  { icon: ShieldCheck, title: "Clear roles", body: "Owner, admin, and member roles decide who manages the workspace." },
  { icon: KeyRound, title: "Edit access on request", body: "Members start view-only and can't run code. Owners and admins grant edit access, and members can request it in-app." },
];

export function BuiltForTeams() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref}>
      <motion.h3 style={{ y: fgY }} className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white text-center max-w-2xl mx-auto mb-12">
        Built for teams.
      </motion.h3>
      <motion.div className="grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#0A0A0F]/10 dark:divide-white/10" style={{ y: bgY }}>
        {FEATURES.map(({ icon: Icon, title, body }, i) => (
          <div key={title} className={`py-6 sm:py-0 ${i > 0 ? "sm:pl-8" : ""} ${i < FEATURES.length - 1 ? "sm:pr-8" : ""}`}>
            <Icon size={18} className="text-[#0284C7] dark:text-[#38BDF8] mb-4" />
            <p className="text-xs font-bold uppercase tracking-widest text-[#0A0A0F] dark:text-white mb-2">{title}</p>
            <p className="text-sm text-[#5C5C66] dark:text-[#9A9A9A]">{body}</p>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
